<template>
  <div class="modal-overlay" @click="onClickOverlay">
    <div :class="['modal !px-4', sizeClass]">
      <div class="modal-image-icon">
        <img
          src="/images/icons/ic-circle-share.svg"
          class="min-w-[80px] max-w-[80px]"
          alt="review"
        />
      </div>
      <button
        v-if="props.showIconClose"
        class="modal-close"
        @click="props.onClose"
      >
        <img
          src="/images/icons/ic-x-mark-close-outline.svg"
          class="min-w-8 max-w-8 min-h-8 max-h-8"
          alt="close"
        />
      </button>

      <div v-if="props.showImage" class="modal-image">
        <img
          :src="
            props.imageSrc
              ? props.imageSrc
              : '/images/graphics/placeholder-image-landscape.svg'
          "
        />

        <div class="image-btn">
          <Button sizeSmall colorPrimary @click="props.onClose">{{
            props.btnTextCancel
          }}</Button>
        </div>
      </div>

      <div v-else>
        <div class="flex flex-col space-y-4 mb-4">
          <h3 class="text-[#330066] text-xl font-semibold">
            {{ props.textTitle }}
          </h3>
          <p v-if="props.subtitle" class="text-[#330066] text-xl">
            {{ props.subtitle }}
          </p>
          <div class="">
            <div class="flex items-center justify-center space-x-2 border border-[#D1D5DB] pl-2 pr-8 break-all py-2 rounded-xl w-full  relative">
              <span class="text-[#330066]">{{ props.sharedUrl }}</span>
              <CopyClipboard className="mt-1" :clipboard="props.sharedUrl" srcImage="/images/icons/ic-clipboard.svg" />
            </div>
            <p v-if="!props.subtitle" class="text-[#B0ACBC] text-xs">Share this conversation internal only - THAI access required</p>
          </div>
        </div>
        <div class="modal-footer !gap-0 space-x-6">
          <Button
            sizeMedium
            colorPrimary
            className="!w-full !h-[57px] !bg-[#734EB0] !rounded-2xl !text-xl hover:!bg-[#5B21B6]"
            @click="props.onConfirm"
            >{{ props.btnTextSuccess }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

// Props
const props = defineProps({
  size: {
    type: String,
    default: 'small',
    validator: (value) => ['small', 'medium', 'large'].includes(value),
  },
  showIconClose: {
    type: Boolean,
    default: true,
  },
  showIcon: {
    type: Boolean,
    default: true,
  },
  showButton2nd: {
    type: Boolean,
    default: true,
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
  iconSwap: {
    type: Boolean,
    default: false,
  },
  slotSwap: {
    type: Boolean,
    default: false,
  },
  textTitle: {
    type: String,
    default: 'Title',
  },
  subtitle: {
    type: String,
    default: '',
  },
  sharedUrl: {
    type: String,
    default: '',
  },
  btnTextSuccess: {
    type: String,
    default: 'Save',
  },
  btnTextCancel: {
    type: String,
    default: 'Cancel',
  },
  onConfirm: {
    type: Function,
    default: function () {},
  },
  onClose: {
    type: Function,
    default: function () {},
  },
  showImage: {
    type: Boolean,
    default: false,
  },
  imageSrc: {
    type: String,
    default: '',
  },
  onChangeInput: {
    type: Function,
    default: function () {},
  },
  onClickOverlay: {
    type: Function,
    default: function () {},
  },
});

// Computed for size classes
const sizeClass = computed(() => {
  return {
    'modal-small': props.size === 'small',
    'modal-medium': props.size === 'medium',
    'modal-large': props.size === 'large',
  };
});

const onClickOverlay = (ev) => {
  if (ev.target !== ev.currentTarget) {
    return;
  }
  props.onClickOverlay();
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
  width: $semantic-dimension-container-width-sm;
  padding: 48px 0px 20px 0px;
  border-radius: 24px;
  position: relative;
  font-family: $typography-font-family-primary;

  .modal-image-icon {
    position: absolute;
    /* top: -15%; */
    top: -68px;
    left: 60%;
    transform: translate(-100%, 40%);
  }
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}
.slot-swap {
  margin-bottom: 20px;
}
.modal-image {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-image img {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
}

.image-btn {
  margin-top: 10px;
}

.modal-small {
  width: $semantic-dimension-container-width-sm;
  padding: 48px 0px 20px 0px;
  gap: 0px;
  border-radius: $semantic-dimension-container-rounded-md;
   
}

.modal-medium {
  width: $semantic-dimension-container-width-md;
  padding: 80px 0px 40px 0px;
  border-radius: 24px;
   
}

.modal-large {
  width: $semantic-dimension-container-width-lg;
  padding: 80px 0px 40px 0px;
  gap: 0px;
  border-radius: $semantic-dimension-container-rounded-md;
   
}

.modal-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.second-button {
  background-color: #0056b3;
  color: white;
}
</style>
